import React from "react";
import { useNavigate } from 'react-router-dom';
import ListVpsExpirePage from "../ListVpsExpirePage";

const PageListVpsExpire = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-vps/chuyen-khach-hang.html?' + listVps);
    }

    let redirectExportExcel = (listVps) => {
        navigate('/dich-vu-vps/xuat-file-excel.html?' + listVps);
    }

    return <ListVpsExpirePage
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
        redirectExportExcel={ (listVps) => redirectExportExcel(listVps) }
    />

}

export default PageListVpsExpire;